export default __webpack_public_path__ + "static/left-ade498d28224e88b05ab4167117c3120.gif";